import { Icon, Text } from '@hotjar/hotsauce';

import { CheckboxItemStyles as S } from './CheckboxItem.styles';
import type { CheckboxItemData } from '../..';

type CheckboxItemProps = {
  isChecked: boolean;
  setIsChecked: () => void;
  data: CheckboxItemData;
  isDisabled: boolean;
};

export const CheckboxItem = ({
  isDisabled,
  isChecked,
  setIsChecked,
  data,
}: CheckboxItemProps): JSX.Element => {
  const checkboxId = `${data.id}-checkbox`;
  return (
    <S.Checkbox>
      <S.CheckboxLabel
        htmlFor={checkboxId}
        selected={isChecked}
        disabled={isDisabled}
        data-testid={`${data.id}-checkbox-label`}
      >
        <S.CheckboxFirstRow>
          <S.CheckboxTitleWrapper>
            <Icon icon={data.icon} size="m" color={isDisabled ? 'text_disabled' : 'text_default'} />
            <S.CheckboxTitle disabled={isDisabled}>{data.title}</S.CheckboxTitle>
          </S.CheckboxTitleWrapper>
          <S.CheckboxInput
            id={checkboxId}
            value="true"
            isChecked={isChecked}
            onChange={setIsChecked}
            isDisabled={isDisabled}
          />
        </S.CheckboxFirstRow>
        <Text textType="body2" textColor="text_light">
          {data.subTitle}
        </Text>
      </S.CheckboxLabel>
    </S.Checkbox>
  );
};
